import { useState } from 'react';

import QRCode from 'qrcode.react';
import { ActionIcon, ButtonMantine, Center, Modal, Stack, Text, Tooltip } from 'ui';
import { IconDownloadTabler, IconQrCode } from 'ui/Icons';

type QRCodeProps = {
  link: string;
  title?: string;
  size?: string;
  opened: boolean;
  onClose: () => void;
};

const QRCodeModal = (props: QRCodeProps) => {
  const { title = 'Untitled', link, opened, onClose } = props;

  const downloadQRCode = () => {
    const canvas = document.getElementById('qr-gen') as HTMLCanvasElement;
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${title}_QRCode.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  return (
    <Modal opened={opened} onClose={onClose} title="QR Code" zIndex={201}>
      <Stack gap={'lg'}>
        <Center>
          <QRCode value={link} id="qr-gen" />
        </Center>
        <Text fz="sm" mb="md" ta="center">
          The QR code is perfect for flyers, banners, or any promotional material where you need to
          provide a direct, easy to use link.
        </Text>
        <Center>
          <ButtonMantine
            rightSection={<IconDownloadTabler brand="tabler" />}
            onClick={downloadQRCode}
          >
            Download QR Code Image
          </ButtonMantine>
        </Center>
      </Stack>
    </Modal>
  );
};

const QRCodeButton = (props: Partial<QRCodeProps>) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { link, title } = props;
  return (
    <>
      <Tooltip label="Download QR Code">
        <ActionIcon size={props.size ?? 'sm'} onClick={() => setIsModalOpen(true)}>
          <IconQrCode />
        </ActionIcon>
      </Tooltip>
      <QRCodeModal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        link={link ?? ''}
        title={title}
      />
    </>
  );
};

export { QRCodeButton, QRCodeModal };
